import { InteractionMetadata } from "../models/Model3D";
import { DebugBox } from "./DebugBox";
import { useFulfillState } from "../hooks/useCheckStateFullfilment";
import { InteractionElementFloatingLabel } from "./InteractionElement.FloatingLabel";
import { InteractionElementFloatingIcon } from "./InteractionElement.FloatingIcon";


export type InteractionElementProps = {
  interaction: InteractionMetadata;
}

export const InteractionElement = (props: InteractionElementProps) => {
  const { interaction } = props;
  const { name, action, stateRequirement: state, type } = interaction;

  const isVisible = useFulfillState(state, true);

  const boundary = <>
    {action?.boundary?.inclusion && <DebugBox
      center={action.boundary.inclusion.center}
      dimension={action.boundary.inclusion.dimension}
      color='blue'
    />
    }
    {action?.boundary?.exclusion && <DebugBox
      center={action.boundary.exclusion.center}
      dimension={action.boundary.exclusion.dimension}
      color='red'
    />}
  </>

  if (!isVisible) {
    return boundary;
  }

  return <>
    {type === 'floatingLabel' && <InteractionElementFloatingLabel interaction={interaction} />}
    {type === 'floatingIcon' && <InteractionElementFloatingIcon interaction={interaction} />}
    {boundary}
  </>

}